import type { KeyboardEvent } from "react";

/**
 * Keyboard grammar for inline compose/rename forms: Enter submits through
 * the form, Escape cancels. Attach the result to the form's `onKeyDown`.
 * The event is consumed so an enclosing dialog does not also close.
 */
export function cancelOnEscape(cancel: () => void): (event: KeyboardEvent<HTMLElement>) => void {
  return (event) => {
    if (event.key !== "Escape" || event.defaultPrevented) return;
    event.preventDefault();
    event.stopPropagation();
    cancel();
  };
}
